<template>
	<div>
		<form v-if="!changeSuccess" class="password-reset-form" v-on:submit.prevent="submit" id="password-reset-form" :action="resetUrl">

			<div><i class="fa fa-lock fa-3x"></i></div>
			<h2>Reset Your Password</h2>

			<form-group label="New Password" col-class="col-md-4">
				<input type="password" name="password" v-model="payload.password" class="form-control">
			</form-group>

			<p>Passwords must be a minimum of 9 characters in length.</p>

			<form-group label="Confirm Password" col-class="col-md-4">
				<input type="password" name="confirm" v-model="payload.confirm" class="form-control">
			</form-group>

			<alert
				:visible="alert.visible"
				:unclosable="true"
				:classes="alert.class" 
				:errors="alert.errors"
				:message="alert.msg">
			</alert>

			<button class="btn btn-primary">Change Password</button>
			
		</form>
		<div class="success-box" v-if="changeSuccess">
			Password changed successfully. You can now <router-link to="/login">login</router-link>
		</div>

	</div>
</template>

<script type="text/javascript">
	import FormGroup from '../components/FormGroup'
	import Alert from '../components/Alert'

	export default {
		name: 'PasswordReset',
		components: {
			FormGroup,
			Alert
		},
		data () {
			return {
				resetUrl: "/user/reset-password",
				token: this.$route.params.token,
				alert: {
					msg: "",
					visible: false,
					class: "",
					errors: []
				},
				changeSuccess: false,
				payload: {
					password: "",
					confirm: "",
					token: this.$route.params.token,
				}
			}
		},
		methods: {
			submit() {
				var vm = this;

				this.postData("user/reset-password",this.payload).then(function(response){
					if (response.success) {
						
						localStorage.userDetails = JSON.stringify(response.data)
						localStorage.apiKey = response.data.api_key
						localStorage.sessionToken = JSON.stringify(response.data.session_token)

						vm.changeSuccess = true

					}
					else {

						vm.alert.visible = true;
						vm.alert.class = "alert-danger"
						vm.alert.errors = response.errors
					}
				});
			}
		},
		created() {
			this.spinner(false)
		}
	}
</script>

<style type="text/css" scoped>
	form, .success-box {
		text-align: center;
		max-width: 500px;
		margin: auto;
		margin-top: 20px;
		padding: 20px;
		box-shadow: 0 0 10px grey;
	}


</style>